<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
  <section class="main-content settings-section">
    <div class="app-main">
      <header>
        <div class="data-header">
          <core-title-section
            [title]="'Invite user'"
            [breadcrumbs]="breadcrumbs"
          ></core-title-section>
        </div>
      </header>
      <div class="inv-add">
        <settings-users-invitations-add (cancelForm)="cancel($event)" (newInvitation)="newInvitation($event)"></settings-users-invitations-add>
      </div>
    </div>
  </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
